module.exports = __webpack_public_path__ + "static/media/dancing-cock.bdf17e7e.gif";